// Where each role lands when it goes "home" — the same mapping App.js's
// DefaultRoute uses for unknown paths, kept in one place so the error screen's
// "Go to home" can never disagree with it.
const ROLE_HOME_PATHS = {
  admin: "/dashboard/dashboard",
  manager: "/DashboardManager/dashboard",
  user: "/userprofile",
  superadmin: "/DashboardSuper",
};

export const getRoleHomePath = (role) =>
  ROLE_HOME_PATHS[String(role || "").toLowerCase()] || null;
